import { defineMessage } from "../messaging/messenger"

export type BarcodeScannerTransport = "webhid" | "keyboard"

export interface BarcodeScannerDevice {
  readonly transport: BarcodeScannerTransport
  readonly productName?: string
  readonly vendorId?: number
  readonly productId?: number
}

export interface BarcodeScan {
  readonly value: string
  readonly aim?: string
  readonly symbology?: string
  readonly device: BarcodeScannerDevice
}

export interface BarcodeScannerUnsupportedEvent {
  readonly transport: BarcodeScannerTransport
  readonly devices: readonly BarcodeScannerDevice[]
}

export const barcodeScannerConnected = defineMessage<BarcodeScannerDevice>("barcode-scanner.connected")
export const barcodeScannerDisconnected = defineMessage<BarcodeScannerDevice>("barcode-scanner.disconnected")
export const barcodeScannerUnsupported = defineMessage<BarcodeScannerUnsupportedEvent>("barcode-scanner.unsupported")
export const barcodeScanned = defineMessage<BarcodeScan>("barcode-scanner.scanned")

export interface BarcodeScanner {
  readonly transport: BarcodeScannerTransport
  readonly supported: boolean
  readonly connectedDevice: BarcodeScannerDevice | null
  connect(): Promise<boolean>
  reconnect(): Promise<boolean>
  disconnect(): Promise<void>
  dispose(): Promise<void>
}
